import type { StoryVersionType } from 'types/story';
import { componentWalkFull } from 'utils/blocks/component-walk-full';
import { getSymbolModel } from 'utils/blocks/get-symbol-model';
import { isSymbol } from 'utils/blocks/symbol';
import { UNIFORM_PROPS } from 'common/constants/component-props';

/** Count affected block identities, resolving mounted symbols and canonical Story references. */
export function countDesignPresetBindings(version: StoryVersionType, presetId: string): number {
	const { elements, steps, symbols = {} } = version.data;
	const ids = new Set<string>();
	const composedInstances = new Set<string>();
	const walk = (nodes: Parameters<typeof componentWalkFull>[0]['elements']) => {
		componentWalkFull({
			elements: nodes,
			symbols,
			storyElements: elements,
			callback: ({ component, stopCurrent }) => {
				// Inline instances also need composition; the shared walker already expands link-only placements.
				if (
					isSymbol(component) &&
					!component.symbol.childId &&
					!composedInstances.has(component.symbol.instanceId)
				) {
					const { masterId, instanceId } = component.symbol;
					if (symbols[masterId]?.instance[instanceId]) {
						composedInstances.add(instanceId);
						stopCurrent();
						walk([getSymbolModel(component, symbols)]);
						return;
					}
				}
				if (component.uiConfig.componentProps[UNIFORM_PROPS.designPresetId] === presetId)
					ids.add(component._id);
			},
		});
	};
	walk(elements);
	for (const step of steps) for (const card of step.cards) walk(card.elements);
	return ids.size;
}
